import type React from 'react';
import { useTranslation } from 'react-i18next';
import {
	formatFirstYearCoverage,
	formatSecondYearCoverage
} from '@/features/Quote/services/coverageUtils';
import type { AppData } from '@/types/app';
import Field from './Field';

interface CoverageDetailsProps {
	appData: AppData;
}

/**
 * Read-only coverage details for the short-term sick-leave product (waiting
 * days, employer's own risk, first/second-year reimbursement). Shown when the
 * reader expands "Dekkingsgegevens" on the sick-leave quotes.
 */
const CoverageDetails = ({ appData }: CoverageDetailsProps): React.JSX.Element => {
	const { t } = useTranslation();
	const coverage = appData.premium_variables?.coverage?.sick_leave_short_term;

	if (!coverage) {
		return (
			<p className="text-sm italic text-muted-foreground/70">
				{t('requestOverview.premiumVars.noCoverage')}
			</p>
		);
	}

	return (
		<dl className="grid grid-cols-2 gap-x-6 gap-y-4 sm:grid-cols-4">
			<Field
				label={t('requestOverview.premiumVars.waitingPeriod')}
				value={coverage.waiting_period}
			/>
			<Field
				label={t('requestOverview.premiumVars.employerCosts')}
				value={coverage.employer_costs != null ? `${coverage.employer_costs}%` : null}
			/>
			<Field
				label={t('requestOverview.premiumVars.coverageFirstYear')}
				value={formatFirstYearCoverage(coverage, t, '')}
			/>
			<Field
				label={t('requestOverview.premiumVars.coverageSecondYear')}
				value={formatSecondYearCoverage(coverage, '')}
			/>
		</dl>
	);
};

export default CoverageDetails;
